<template lang="pug">
  section.section.verify-email

    h1.title E-Mail-Bestätigung

    .wait-for-mail(v-if="!token") Bitte bestätige Deine E-Mail-Adresse durch den eben an Dich versandten Link.

    .text(v-if="itWorked === true") Viel Spaß mit Deiner ersten Liste:&nbsp;
      router-link(to="/login") Logge Dich jetzt ein!

    .text(v-if="itWorked === false") Es tut uns Leid, aber mit Deinem Link ist irgendetwas faul.
      br
      br
      a(href="#", @click.prevent="resend") Hier
      |  kannst Du aber eine neue Bestätigungsmail anfordern.

</template>

<script>

export default {
  // components: {BInput},
  name: 'EmailVerificationPage',
  data () {
    return {
      token: null,
      itWorked: undefined,
      message: null,
      email: null
    }
  },
  created () {
    if (this.$route.params.token) {
      this.token = this.$route.params.token

      this.axios.post('/registration/verify-email/', { key: this.token }).then(response => {
        this.itWorked = true
      }).catch(response => {
        this.itWorked = false
        console.log(response)
      })
    }
  },
  methods: {
    resend: function () {
      this.$dialog.prompt({
        message: `Wie lautet Deine E-Mail-Adresse?`,
        inputAttrs: {
          placeholder: '',
          maxlength: 100,
          id: 'email'
        },
        confirmText: 'Absenden',
        cancelText: 'Abbrechen',
        onConfirm: (value) => {
          this.axios.post('/registration/resend-activation-email/', { email: value }).then(response => {
            this.token = undefined
            this.itWorked = undefined
          })
        }
      })
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.text, .wait-for-mail, .title
  text-align: center

</style>
